import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, objectSpread2 as _objectSpread2, typeof as _typeof, asyncToGenerator as _asyncToGenerator, createClass as _createClass, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../../node_modules/prop-types/index.js';
import React from 'react';
import { connect } from 'react-redux';
import { resetList, changeFilters, changePagination, changeSelection, clearState } from '../actions.js';
import { ListBuilderResetStateType } from '../types.js';
import { getBuilderData } from '../selectors.js';
import { debounce } from '../../../modules/utility/debounce.js';
import { getPreferenceValue } from '../../../modules/preferences/selectors.js';
import { updatePreference } from '../../../modules/preferences/actions.js';
import { compareParams } from '../../../modules/utility/params.js';
import { abortableApi } from '../../../modules/abort/actions.js';

var ALL_LIST_RESET_OPTIONS = [ListBuilderResetStateType.Data, ListBuilderResetStateType.Filters, ListBuilderResetStateType.Pagination, ListBuilderResetStateType.Selection];

var ListBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ListBase, _React$Component);

  var _super = _createSuper(ListBase);

  function ListBase(_props) {
    var _this;

    _classCallCheck(this, ListBase);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "defaultCommonState", function () {
      return {
        error: undefined
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultDataState", function (props) {
      return {
        data: props.initialData !== undefined && props.initialData !== null ? props.dataTransform(props.initialData) : [],
        total: props.initialData !== undefined && props.initialData !== null ? props.totalTransform(props.initialData) : 0,
        loading: false,
        slowLoading: false,
        loadingMore: false
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultInitialState", function (props) {
      return _objectSpread2(_objectSpread2({}, _this.defaultCommonState()), _this.defaultDataState(props));
    });

    _defineProperty(_assertThisInitialized(_this), "defaultResetState", function (props, resetOptions) {
      return _objectSpread2(_objectSpread2({}, _this.defaultCommonState()), resetOptions.includes(ListBuilderResetStateType.Data) ? _this.defaultDataState(props) : {});
    });

    _defineProperty(_assertThisInitialized(_this), "resetReduxState", function (props, resetOptions) {
      var clearPreferences = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var resetList = props.resetList,
          filters = props.filters,
          pagination = props.pagination,
          selection = props.selection,
          initialFilterCalc = props.initialFilterCalc,
          initialPaginationCalc = props.initialPaginationCalc,
          initialSelectionCalc = props.initialSelectionCalc,
          preferenceFilters = props.preferenceFilters;
      resetList(resetOptions.includes(ListBuilderResetStateType.Filters) ? clearPreferences || !preferenceFilters ? initialFilterCalc : preferenceFilters : filters, resetOptions.includes(ListBuilderResetStateType.Pagination) ? initialPaginationCalc : pagination, resetOptions.includes(ListBuilderResetStateType.Selection) ? initialSelectionCalc : selection, clearPreferences);
    });

    _defineProperty(_assertThisInitialized(_this), "parseReloadOption", function (options) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return _typeof(options) === "object" && options.hasOwnProperty("reload") ? !!options.reload : defaultValue;
    });

    _defineProperty(_assertThisInitialized(_this), "parseResetOptions", function (options) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ALL_LIST_RESET_OPTIONS;
      return _typeof(options) === "object" && Array.isArray(options.reset) ? options.reset : defaultValue;
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_loadingKey", undefined);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;

      _this.loadData();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;

      _this.onAbortLoad();

      _this.props.clearState();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (!compareParams(_this.props.loadParams, prevProps.loadParams)) {
        _this.onRefresh();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _updates$filters, _updates$pagination;

      var updates,
          _this$props,
          dataTransform,
          totalTransform,
          loadAction,
          loadParams,
          loadTransform,
          loadSlowDelay,
          onLoad,
          onLoaded,
          dispatch,
          selection,
          filters,
          pagination,
          _data,
          loadResponse,
          loadingKey,
          loadingAction,
          slowTimeout,
          _yield$dispatch,
          success,
          error,
          response,
          _args = arguments;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              updates = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _this$props = _this.props, dataTransform = _this$props.dataTransform, totalTransform = _this$props.totalTransform, loadAction = _this$props.loadAction, loadParams = _this$props.loadParams, loadTransform = _this$props.loadTransform, loadSlowDelay = _this$props.loadSlowDelay, onLoad = _this$props.onLoad, onLoaded = _this$props.onLoaded, dispatch = _this$props.dispatch, selection = _this$props.selection;
              filters = (_updates$filters = updates === null || updates === void 0 ? void 0 : updates.filters) !== null && _updates$filters !== void 0 ? _updates$filters : _this.props.filters;
              pagination = (_updates$pagination = updates === null || updates === void 0 ? void 0 : updates.pagination) !== null && _updates$pagination !== void 0 ? _updates$pagination : _this.props.pagination;

              if (onLoad) {
                _data = onLoad({
                  filters: filters,
                  pagination: pagination,
                  selection: selection
                }, loadParams);

                _this.setState({
                  data: dataTransform(_data),
                  total: totalTransform(_data)
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 24;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction({
                filters: filters,
                pagination: pagination,
                selection: selection
              }, loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              _context.next = 14;
              return dispatch(loadingAction);

            case 14:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 21;
                break;
              }

              return _context.abrupt("return");

            case 21:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 23;
                break;
              }

              return _context.abrupt("return");

            case 23:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response, {
                  filters: filters,
                  pagination: pagination,
                  selection: selection
                });

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  data: dataTransform(loadResponse),
                  total: totalTransform(loadResponse)
                });
              }

            case 24:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "loadMore", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$props2, dataTransform, totalTransform, loadAction, loadParams, loadTransform, onLoad, onLoaded, dispatch, filters, selection, _this$state, data, total, prevPagination, pagination, response, loadResponse, loadingKey, loadingAction, _yield$dispatch2, success, error, _response;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, dataTransform = _this$props2.dataTransform, totalTransform = _this$props2.totalTransform, loadAction = _this$props2.loadAction, loadParams = _this$props2.loadParams, loadTransform = _this$props2.loadTransform, onLoad = _this$props2.onLoad, onLoaded = _this$props2.onLoaded, dispatch = _this$props2.dispatch, filters = _this$props2.filters, selection = _this$props2.selection; // work out pagination required to get more data

              _this$state = _this.state, data = _this$state.data, total = _this$state.total;

              if (!(data.length >= total)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              prevPagination = _this.props.pagination;
              pagination = _objectSpread2(_objectSpread2({}, prevPagination), {}, {
                pageNumber: (prevPagination.pageNumber || 0) + 1
              });

              _this.props.changePagination(pagination);

              if (onLoad) {
                response = onLoad({
                  filters: filters,
                  pagination: pagination,
                  selection: selection
                }, loadParams);

                _this.setState({
                  data: [].concat(_toConsumableArray(data), _toConsumableArray(dataTransform(response))),
                  total: totalTransform(response)
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context2.next = 25;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction({
                filters: filters,
                pagination: pagination,
                selection: selection
              }, loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loadingMore: true,
                error: undefined
              });

              _context2.next = 16;
              return dispatch(loadingAction);

            case 16:
              _yield$dispatch2 = _context2.sent;
              success = _yield$dispatch2.success;
              error = _yield$dispatch2.error;
              _response = _yield$dispatch2.response;

              if (_this._isMounted) {
                _context2.next = 22;
                break;
              }

              return _context2.abrupt("return");

            case 22:
              if (!(loadingKey !== _this._loadingKey)) {
                _context2.next = 24;
                break;
              }

              return _context2.abrupt("return");

            case 24:
              if (!success || !_response) {
                _this.setState({
                  loadingAbort: undefined,
                  loadingMore: false,
                  error: error
                }); // revert state to allow retries


                _this.props.changePagination(prevPagination);
              } else {
                loadResponse = loadTransform(_response, {
                  filters: filters,
                  pagination: pagination,
                  selection: selection
                });

                _this.setState({
                  loadingAbort: undefined,
                  loadingMore: false,
                  data: [].concat(_toConsumableArray(data), _toConsumableArray(dataTransform(loadResponse))),
                  total: totalTransform(loadResponse)
                });
              }

            case 25:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "onReset", function (options) {
      var reloadOption = _this.parseReloadOption(options);

      var resetOptions = _this.parseResetOptions(options);

      _this.resetReduxState(_this.props, resetOptions);

      var defaultState = _this.defaultResetState(_this.props, resetOptions);

      _this.setState(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), defaultState);
      }, reloadOption ? _this.loadData : undefined);
    });

    _defineProperty(_assertThisInitialized(_this), "onRefresh", function () {
      return _this.onReset({
        reload: true,
        reset: [ListBuilderResetStateType.Pagination, ListBuilderResetStateType.Selection]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeFilters", function (filters) {
      _this.props.changeFilters(filters);

      _this.loadData({
        filters: filters
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangePagination", function (pagination) {
      _this.props.changePagination(pagination);

      _this.loadData({
        pagination: pagination
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeSelection", function (selection) {
      _this.props.changeSelection(selection);
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _this.state = _this.defaultInitialState(_props);
    _this.onChangeFilters = debounce(_this.onChangeFilters, _props.debounceFilters);
    _this.onChangePagination = debounce(_this.onChangePagination, _props.debouncePagination);

    _this.resetReduxState(_props, ALL_LIST_RESET_OPTIONS, false);

    return _this;
  }

  _createClass(ListBase, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          loading = _this$state2.loading,
          slowLoading = _this$state2.slowLoading,
          loadingMore = _this$state2.loadingMore,
          error = _this$state2.error,
          data = _this$state2.data,
          total = _this$state2.total;
      var _this$props3 = this.props,
          filters = _this$props3.filters,
          pagination = _this$props3.pagination,
          selection = _this$props3.selection,
          initialData = _this$props3.initialData,
          initialFilters = _this$props3.initialFilters,
          initialPagination = _this$props3.initialPagination,
          initialSelection = _this$props3.initialSelection;
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        error: error,
        filters: filters,
        pagination: pagination,
        selection: selection,
        total: total,
        hasMore: data && data.length < total,
        loadingMore: loadingMore,
        initialData: initialData,
        initialFilters: initialFilters,
        initialPagination: initialPagination,
        initialSelection: initialSelection
      };
      var events = {
        onReset: this.onReset,
        onRefresh: this.onRefresh,
        onChangeFilters: this.onChangeFilters,
        onChangePagination: this.onChangePagination,
        onChangeSelection: this.onChangeSelection,
        onLoadMore: this.loadMore,
        onAbortLoad: this.onAbortLoad
      };
      return this.props.render(data, state, events);
    }
  }]);

  return ListBase;
}(React.Component);

_defineProperty(ListBase, "propTypes", {
  initialData: _pt.any,
  initialFilters: _pt.any.isRequired,
  initialPagination: _pt.any.isRequired,
  initialSelection: _pt.any.isRequired,
  dataTransform: _pt.func.isRequired,
  totalTransform: _pt.func.isRequired,
  loadAction: _pt.func,
  loadParams: _pt.any,
  loadTransform: _pt.func.isRequired,
  loadSlowDelay: _pt.number.isRequired,
  onLoad: _pt.func,
  onLoaded: _pt.func,
  persistFilters: _pt.string,
  debounceFilters: _pt.number.isRequired,
  debouncePagination: _pt.number.isRequired,
  render: _pt.func.isRequired,
  id: _pt.string.isRequired,
  initialFilterCalc: _pt.any.isRequired,
  initialPaginationCalc: _pt.any.isRequired,
  initialSelectionCalc: _pt.any.isRequired,
  preferenceFilters: _pt.oneOfType([_pt.any, _pt.oneOf([null])]),
  filters: _pt.any.isRequired,
  pagination: _pt.any.isRequired,
  selection: _pt.any.isRequired,
  dispatch: _pt.any.isRequired,
  resetList: _pt.func.isRequired,
  changeFilters: _pt.func.isRequired,
  changePagination: _pt.func.isRequired,
  changeSelection: _pt.func.isRequired,
  clearState: _pt.func.isRequired
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var data = getBuilderData(state, ownProps.id);
  var preferenceFilters = ownProps.persistFilters ? getPreferenceValue(state, ownProps.persistFilters) : null;
  var initialFilterCalc = ownProps.initialFilters;
  var initialPaginationCalc = ownProps.initialPagination;
  var initialSelectionCalc = ownProps.initialSelection;
  return {
    initialFilterCalc: initialFilterCalc,
    initialPaginationCalc: initialPaginationCalc,
    initialSelectionCalc: initialSelectionCalc,
    preferenceFilters: preferenceFilters,
    filters: data.filters || preferenceFilters || initialFilterCalc,
    pagination: data.pagination || initialPaginationCalc,
    selection: data.selection || initialSelectionCalc
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch: dispatch,
    resetList: function resetList$1(filters, pagination, selection, clearPreferences) {
      dispatch(resetList(ownProps.id, filters, pagination, selection));

      if (clearPreferences && ownProps.persistFilters) {
        dispatch(updatePreference(ownProps.persistFilters, filters));
      }
    },
    changeFilters: function changeFilters$1(filters) {
      dispatch(changeFilters(ownProps.id, filters));

      if (ownProps.persistFilters) {
        dispatch(updatePreference(ownProps.persistFilters, filters));
      }
    },
    changePagination: function changePagination$1(pagination) {
      return dispatch(changePagination(ownProps.id, pagination));
    },
    changeSelection: function changeSelection$1(selection) {
      return dispatch(changeSelection(ownProps.id, selection));
    },
    clearState: function clearState$1() {
      return dispatch(clearState(ownProps.id));
    }
  };
};

var connectBase = function connectBase() {
  return connect(mapStateToProps, mapDispatchToProps)(ListBase);
};

var ListBaseComponent = connectBase();

var ListBase$1 = function ListBase$1(props) {
  return /*#__PURE__*/React.createElement(ListBaseComponent, props);
};

export { ListBase$1 as default };
